export default {
  id: null,
  nome: null,
  url: null,
  usuario: null,
  senha: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/campanhaencurtadormodel.js